export enum PasswordStrength {
  VeryStrong = 100,
  Strong = 80,
  Moderate = 60,
  Weak = 40,
  VeryWeak = 20,
  Nothing = 0
}
